/* Two halves and a coda. Hardware was split across "Primary" and "Work" and
   Software across "Tools" and "Dev", which meant four tabs to answer two
   questions: what do you type on, and what do you type into. */
const allCategories = [
  {
    id: 'hardware',
    label: 'Hardware',
    title: 'Hardware',
    description: 'The desks, the machines, the things I plug into them',
    pageDescription: 'The machines I use at home and at work.',
    hotkey: 'H',
  },
  {
    id: 'software',
    label: 'Software',
    title: 'Software',
    description: 'What I write code in, and what I run the rest of my life on',
    pageDescription: 'The software I build with and work in.',
    hotkey: 'S',
  },
  {
    id: 'quotes',
    // Hidden from production until the quotes are checked: several were
    // misattributed, and not all of them are from books.
    draft: true,
    label: 'Quotes',
    title: 'Quotes',
    description: 'Lines from books that stuck',
    pageDescription: 'Words that have stuck with me.',
    hotkey: 'Q',
  },
];

// Drafts show in development only, like draft posts.
export const categories = allCategories.filter(
  category => !category.draft || process.env.NODE_ENV !== 'production'
);
